import { Box, Button } from '@mui/material';
import { InlineNotice } from '../../design-system';
import type { AsyncResource } from '../../shared/useAsyncResource';
import type { PublicHolidayDates } from './publicHolidayModel';

export function PublicHolidayNotice({ resource, inset = true }: { resource: AsyncResource<PublicHolidayDates>; inset?: boolean }) {
  if (resource.loading) return null;
  const missingYears = resource.data?.missingYears ?? [];
  if (!resource.error && !missingYears.length) return null;
  return <Box sx={{ px: inset ? 2 : 0, pb: 1 }}>
    <InlineNotice density="compact" severity={resource.error ? 'warning' : 'info'} announcement={resource.error ? 'polite' : 'off'}
      action={resource.error ? <Button size="small" color="inherit" onClick={resource.reload}>공휴일 다시 불러오기</Button> : undefined}
    >
      {resource.error
        ? '공휴일을 불러오지 못했습니다. 휴가 일정은 계속 확인할 수 있습니다.'
        : `${missingYears.map((year) => `${year}년`).join(' · ')} 공휴일이 아직 준비되지 않았습니다. 관리자에게 공휴일 갱신을 요청해 주세요.`}
    </InlineNotice>
  </Box>;
}
